/*globals jQuery */
(function( $ ) {
	'use strict';

	// Define global object.
	if ( typeof window.MSR !== 'object' ) {
		window.MSR = {};
	}

	window.MSR.searchForm = (function() {

		var form = null;

		var init = function() {
			var datepicker = $( '.loadDatepicker' );
			form = $( document.getElementById( 'msrFacetedSearchFacets' ) );

			if ( datepicker.length && form.length ) {
				facetSearchDateFields();
			} else if ( datepicker.length && document.getElementById( 'msr-search-form' ) ) {
				legacySearchDateFields();
			}

			if ( form.length === 0 ) {
				return;
			}

			bindPersonSelect2();

		};

		var bindPersonSelect2 = function() {

			var $select2_element = form.find( '.person-select2' );

			if ( $select2_element.length === 0 ) {
				return;
			}

			var select2_options = {
				width: '100%',
				allowClear: true,
				placeholder: $select2_element.data( 'placeholder' )
			};

			select2_options.ajax = {
				url: form.data( 'ajax-url' ),
				dataType: 'json',
				delay: 100,
				data: function( params ) {
					return {
						search: params.term
					};
				},

				headers: {
					"X-WP-Nonce": form.data( 'ajax-nonce' )
				},

				processResults: function( data, params ) {
					var items = [];
					var response_items = data.researchers;
					// format the item for the select2 box
					for ( var i = 0; i < response_items.length; i++ ) {
						var item = { id: response_items[ i ].user_nicename, text: response_items[ i ].display_name };
						items[ items.length ] = item;
					}
					return {
						results: items
					};

				}
			};

			$select2_element.select2( select2_options );
		};

		var pikadayToString = function ( date ) {
			var day = date.getDate();
			var month = date.getMonth() + 1;
			var year = date.getFullYear();
			var arr = [ year, month, day ];

			return arr.join( '-' );
		};

		var pikadayParse = function ( datestring ) {
			var values = datestring.split( '-' );
			var year;
			var month;
			var day;

			if ( values.length === 3 ) {
				year = values[0];
				month = values[1];
				day = values[2];
			} else if ( values[0] !== '' ) {
				year = values[0];
				month = 11;
				day = 31;
			}

			return new Date( year, month, day );
		};

		var legacySearchDateFields = function () {
			var Pikaday = window.Pikaday;
			var startDate = document.getElementById( 'from_date' );
			var endDate = document.getElementById( 'to_date' );

			if ( ! Pikaday ) {
				return;
			}

			if ( ! startDate || ! endDate ) {
				return;
			}

			new Pikaday( {
				field: endDate,
				format: 'YYYY-MM-DD',
				toString: pikadayToString,
				parse: pikadayParse,
			} );

			new Pikaday( {
				field: startDate,
				format: 'YYYY-MM-DD',
				toString: pikadayToString,
				parse: pikadayParse,
			} );
		};

		var facetSearchDateFields = function() {

			if ( ! window.Pikaday ) {
				return;
			}

			var Pikaday = window.Pikaday;
			var startDate = document.getElementById( 'startdate' );
			var endDate = document.getElementById( 'enddate' );
			var startPikaday;
			var endPikaday;

			if ( ! startDate || ! endDate ) {
				return;
			}

			if ( endDate.value === '' ) {
				endDate.disabled = true;
			}

			endPikaday = new Pikaday( {
				field: endDate,
				format: 'YYYY-MM-DD',
				toString: pikadayToString,
				parse: pikadayParse
			} );

			startPikaday = new Pikaday( {
				field: startDate,
				format: 'YYYY-MM-DD',
				toString: pikadayToString,
				onSelect: function( date ) {
					if ( date !== '' ) {
						endPikaday.setMinDate( date );
						endDate.value = '';
					}
				},
				parse: pikadayParse
			} );

		}; // dateFields()

		return {
			init: init
		};

	})();

	$( function() {
		window.MSR.searchForm.init();
	} );
})( jQuery );
